
// @flow
import { createSelector } from 'reselect';
import moment from 'moment-timezone';
import petrovich from 'petrovich';
import prop from 'ramda/es/prop';


export default createSelector(
  [
    (state, { params: { id } }) => state.students.data[id],
    (_, { params: { date } }) => date,
    (_, { params: { date2 } }) => date2,
    (_, { t }) => t,
  ],
  (student, date, date2, t) => {
    const dateMoment = moment(date);
    const dateMoment2 = date2 && moment(date2);

    const dateOf = !date2
      ? dateMoment.format('L')
      : `${dateMoment.format('L')} — ${dateMoment2.format('L')}`;

    if (!student) {
      return t('header_noname', { date: dateOf });
    }

    const { name, gender } = student;

    const who = prop('first', petrovich({ ...name, gender }, 'genitive'));
    return t('header', { name: who, date: dateOf });
  }
);
